let mockBanList = [
    { student_number: "202012345" },
    { student_number: "202112346" },
    { student_number: "202212347" }
];

const getAll = async () => {
    return Promise.resolve({
        data: {
            data: [...mockBanList]
        }
    });
};

const add = async (studentNumber) => {
    if (!mockBanList.find((r) => r.student_number === studentNumber)) {
        mockBanList.push({ student_number: studentNumber });
    }
    return Promise.resolve({ data: { message: 'success' } });
};

const remove = async (studentNumber) => {
    mockBanList = mockBanList.filter((r) => r.student_number !== studentNumber);
    return Promise.resolve({ data: { message: 'success' } });
};

const removeAll = async () => {
    mockBanList = [];
    return Promise.resolve({ data: { message: 'success' } });
};

const exportExcel = async () => {
    return Promise.resolve({ data: { data: [...mockBanList] } });
};

export default {
    getAll,
    add,
    remove,
    removeAll,
    exportExcel
};
